module.exports = __webpack_public_path__ + "static/nucleus-64aa4e8a26f9d1f6be8b276ac1b488a8.png";